import { v4 as uuidv4 } from 'uuid'
import JobTypes from '../helpers/JobTypesEnum'
import { STORAGE_PATH } from '../config'

const otimoKarater = {
  id: uuidv4(),
  name: 'ótimoKaráter',
  path: '/otimokarater',
  bios: [
    'Heterônimo/projeto sonoro do artista Marcelo Mudou, com o qual investiga aspectos da atmosfera paranóica da vida privada contemporânea. Seja no formato de apresentações ao vivo, exposições, trilhas sonoras ou ep ‘s, aborda o som como um elemento que nos guia pelas relações psicológicas da vida na cidade. Marcelo é também um dos fundadores do selo Domina, que desde 2013 contribui para a difusão de uma nova música eletrônica brasileira.',
    'Heteronym/sound project of artist Marcelo Mudou, in which he investigates aspects of the paranoid atmosphere of contemporary private life. Whether in the form of live presentations, exhibitions, soundtracks or EP ’s, the artist addresses sound as an element that guides us through the psychological relationships of urban life. Marcelo is also one of the founders of Domina label, which since 2013 has contributed to the spread of new Brazilian electronic music.',
  ],
  jobs: [
    {
      id: uuidv4(),
      title: 'Estranhas Modalidades',
      type: JobTypes.AUDIO,
      path: '/estranhas-modalidades',
      image: '/assets/otimokarater/estranhas-modalidades.png',
      imageHover: '/assets/otimokarater/estranhas-modalidades_hover.png',
      texts: [
        'Curtas narrativas sonoras baseadas em situações reais localizadas no interior de cenários íntimos.',
        'Short sound narratives based on real situations located within intimate scenarios.',
      ],
      pages: [
        {
          id: uuidv4(),
          link: 'Trailer',
          title: 'Estranhas Modalidades',
          src: `${STORAGE_PATH}/ótimoKaráter/Estranhas+Modalidades+Trailer.mp3`,
          path: '/trailer',
        },
        {
          id: uuidv4(),
          link: 'Track 1',
          title: 'Serpro',
          src: `${STORAGE_PATH}/ótimoKaráter/SERPRO.mp3`,
          path: '/1',
        },
        {
          id: uuidv4(),
          link: 'Track 2',
          title: 'Protocolo Superior',
          src: `${STORAGE_PATH}/ótimoKaráter/Protocolo+Superior.mp3`,
          path: '/2',
        },
      ]
    },
  ],
}

export default otimoKarater
